import {DndContext} from "@dnd-kit/core"
import {restrictToParentElement} from "@dnd-kit/modifiers"
import {ActionContext} from "../../../../src/context/ActionContextProvider"
import React, {useContext} from "react"
import Content from "../../../components/Content"
import {getMerkmal} from "../../../misc/widget-functions"
import {DataContext} from "../../../../src/context/DataContextProvider"
import {fileServerUrlParser} from "../../../misc/utils"
import {Grid, Typography} from "@mui/material"
import DraggableItem from "./DragableItem"

const DragAndDropWrapper = ({container}) => {
    const {triggerAction} = useContext(ActionContext)
    const {getDataFromPointer} = useContext(DataContext)
    const {action} = container
    const pointer = getMerkmal(container)?.pointer
    const data = getDataFromPointer(pointer) ?? []

    const onDragEnd = ({active, delta}) => {
        const item = data.find((d, index) => (d.id ?? index) === active.id)
        const currentX = item?.x ?? 0
        const currentY = item?.y ?? 0

        const payload = {
            ...item,
            id: active.id,
            x: currentX + delta.x,
            y: currentY + delta.y,
        }

        action && triggerAction(action, payload)
    }

    return (
        <div style={{position: "relative"}}>
            <DndContext
                onDragEnd={onDragEnd}
                modifiers={[restrictToParentElement]}>
                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        pointerEvents: "none",
                    }}>
                    {data.map((item, index) => {
                        const id = item.id ?? index
                        return (
                            <DraggableItem
                                key={id}
                                id={id}
                                style={{
                                    top: item.y ?? 0,
                                    left: item.x ?? 0,
                                    pointerEvents: "auto",
                                }}>
                                <Grid
                                    container
                                    direction="column"
                                    alignItems="center"
                                    justifyContent="center">
                                    {item.icon && (
                                        <img
                                            src={fileServerUrlParser(item.icon)}
                                            alt={item.longname}
                                        />
                                    )}
                                    <Typography
                                        fontSize="14px"
                                        color="inherit">
                                        {item.longname}
                                    </Typography>
                                </Grid>
                            </DraggableItem>
                        )
                    })}
                </div>
                {container.children.map((item) => (
                    <Content
                        key={item.id}
                        child={item}
                    />
                ))}
            </DndContext>
        </div>
    )
}

export default DragAndDropWrapper
